import HistoryCard from "./HistoryCard";
import {
  fetchAccounts,
  fetchSavings,
  fetchBudgets,
  fetchInvestments,
  fetchDebts,
  fetchMortgages,
} from "../../../../../../app/store/slices/historySlice";
import { useCanvas } from '../../../../context/CanvasContext';
import {accountColumns,savingColumns, budgetColumns,
   debtColumns, mortgageColumns, investmentColumns } from '../../../../../../utils/constants/dashboardConstants';


const HistoryContent = () => {
  const { selectedCanvas } = useCanvas();
  const canvasId = selectedCanvas?.id;
  return(
  <div className="max-w-7xl mx-auto px-4">
    <h1 className="text-xl md:text-2xl font-bold text-center mb-4 md:mb-6">
      History
    </h1>
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
      <HistoryCard
        title="Accounts"
        columns={accountColumns}
        fetchThunk={fetchAccounts}
        selector={state => state.history.accounts}
        canvasId={canvasId}
      />
      <HistoryCard
        title="Budget"
        columns={budgetColumns}
        fetchThunk={fetchBudgets}
        selector={state => state.history.budgets}
        canvasId={canvasId}
      />
      <HistoryCard
        title="Savings"
        columns={savingColumns}
        fetchThunk={fetchSavings}
        selector={state => state.history.savings}
        canvasId={canvasId}
      />
      <HistoryCard
        title="Debt"
        columns={debtColumns}
        fetchThunk={fetchDebts}
        selector={state => state.history.debts}
        canvasId={canvasId}
      />
      <HistoryCard
        title="Mortgages"
        columns={mortgageColumns}
        fetchThunk={fetchMortgages}
        selector={state => state.history.mortgages}
        canvasId={canvasId}
      />
      <HistoryCard
        title="Investments"
        columns={investmentColumns}
        fetchThunk={fetchInvestments}
        selector={state => state.history.investments}
        canvasId={canvasId}
      />
    </div>
  </div>
)};

export default HistoryContent;